import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getColoradoSpringsStructuredData() {
  const url = "https://restorehair.com/locations/colorado/colorado-springs/";
  const description =
    "Find out about your hair transplant options in Colorado Springs with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("colorado-springs", url, description),
    locationPageCrumbs(url, "Colorado Springs"),
  ];
}
